import { ApiLegacyCustomElementResponse, ApiTransitionElementResponse } from '../../api/core/models';
import { Language } from '../../model/enums/language';
import { TransitionElement } from '../../model/enums/transition-element';
import {
  generateModelTranslationKey,
  ModelTranslationOutputType,
} from '../../services/climate-engine/ccc-model-utility/generate-model-translation-key';
import { TranslationService } from '../../services/translation-service';
import { getIconPath } from '../get-icon-path';

/**
 * Gets the title for a transition element or legacy custom element
 * @param element The element to get the title for
 * @param translationService The translation service to use for translating titles
 * @param language The language to translate to
 * @returns The title of the element
 */
export function getElementTitle(
  element: ApiTransitionElementResponse | ApiLegacyCustomElementResponse,
  translationService: TranslationService,
  language: Language
): string {
  const transitionElement = element as ApiTransitionElementResponse;
  const legacyCustomElement = element as ApiLegacyCustomElementResponse;

  if (
    transitionElement.transitionElement ||
    (legacyCustomElement?.linkedTransitionElement?.length && legacyCustomElement?.linkedTransitionElement?.length > 0)
  ) {
    return translationService.translate(
      language,
      generateModelTranslationKey(
        ModelTranslationOutputType.TransitionElementTitle,
        transitionElement.transitionElement ?? legacyCustomElement?.linkedTransitionElement
      )
    );
  }
  return legacyCustomElement.title ?? '';
}

/**
 * Gets the icon path for a transition element or legacy custom element
 * @param element The element to get the icon for
 * @returns The path to the icon
 */
export function getElementIconPath(element: ApiTransitionElementResponse | ApiLegacyCustomElementResponse): string {
  const transitionElement = element as ApiTransitionElementResponse;
  if (transitionElement.transitionElement) {
    return getIconPath(transitionElement.transitionElement as TransitionElement);
  }
  const legacyCustomElement = element as ApiLegacyCustomElementResponse;
  return getIconPath(
    (legacyCustomElement?.linkedTransitionElement?.length && legacyCustomElement?.linkedTransitionElement?.length > 0
      ? legacyCustomElement?.linkedTransitionElement
      : 'default') as TransitionElement
  );
}
